import { connect } from 'react-redux'
import Selection from './Selection.jsx'
import { isCollaborativeIndexationCreationSelectionToolActive } from '../../../../../redux/collaborativeIndexations/selectors'
import { toggleCollaborativeIndexationCreationSelection } from '../../../../../redux/collaborativeIndexations/actions'

const mapDispatchToProps = (dispatch, getState) => ({
    toggleSelection: () => dispatch(toggleCollaborativeIndexationCreationSelection())
})

const mapStateToProps = (state, ownProps) => ({
    isSelectionToolActive: isCollaborativeIndexationCreationSelectionToolActive(state),
})

export const SelectionContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Selection)
